import { render } from "./AccountsBox.vue?vue&type=template&id=ce2b8e9c&scoped=true"
import script from "./AccountsBox.vue?vue&type=script&lang=js"
export * from "./AccountsBox.vue?vue&type=script&lang=js"

import "./AccountsBox.vue?vue&type=style&index=0&id=ce2b8e9c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce2b8e9c"]])

export default __exports__